/**
 * WebSocket URL: dev'de doğrudan backend (:3333), prod'da aynı host.
 * CRA ws proxy güvenilir değil; backend localhost:3000 origin'ini kabul eder.
 */
export function getWebSocketUrl(path) {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;

  if (process.env.REACT_APP_WS_BASE_URL) {
    const base = process.env.REACT_APP_WS_BASE_URL.replace(/\/$/, '');
    return `${base}${normalizedPath}`;
  }

  if (process.env.NODE_ENV === 'development') {
    const backendHost = process.env.REACT_APP_BACKEND_HOST || 'localhost:3333';
    return `ws://${backendHost}${normalizedPath}`;
  }

  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${protocol}//${window.location.host}${normalizedPath}`;
}
